<template>
  <div>
    <va-modal
      class="modal"
      v-model="showEdition"
      :okText="saveMessage"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="saveDevis"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
      :hideDefaultActions="true"
      disabled
      title="Création d'un devis"
    >
      <div class="forcewidth">
        <div class="row row-inside">
          <div class="flex md5">
            <div class="row row-inside">
              <div class="flex md12">
                <va-select
                  :options="partenairesListe"
                  v-model="partenaire"
                  textBy="nom"
                  keyBy="idpartenaire"
                  searchable
                  label="Annonceur"
                />
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md6 pr-1">
                <va-select
                  :options="mainContactList"
                  v-model="mainContactDevis"
                  textBy="display"
                  keyBy="idcontacts_partenaire"
                  label="Adresse principale du devis"
                  clearable="false"
                />
              </div>
              <div class="flex md6 pl-1">
                <va-select
                  :options="mainContactList"
                  v-model="mainContact"
                  textBy="display"
                  keyBy="idcontacts_partenaire"
                  label="Adresse de facturation"
                />
              </div>
            </div>
            <div class="row row-inside">
              <div class="flex md2">Attribution:</div>
              <div class="flex md1">
                <va-checkbox v-model="attribution" />
              </div>

              <div class="flex md3">TVA non applicable:</div>
              <div class="flex md1">
                <va-checkbox v-model="tva_na" />
              </div>
              <div class="flex md5">
                <va-toggle
                  small
                  v-model="isprospection"
                  label="Devis de prospection"
                />
              </div>
            </div>
          </div>
          <div class="flex md5">
            <div class="row row-inside">
              <div class="flex md12 offset--md1">
                <div class="row row-inside">
                  <div class="flex md3">
                    Engagement sur {{ decomptesNumeros }} numéros
                  </div>
                  <div class="flex md5">{{ decomptePages.text }}</div>
                  <div class="flex md3">{{ decomptePages.total }}</div>
                  <div class="flex md2">Total: {{ montants.total }} €</div>
                  <div class="flex md2">Remise: {{ montants.remise }} €</div>
                  <div class="flex md2">
                    Total remisé: {{ montants.total - montants.remise }} €
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex md2">
            <div class="row row-inside">
              <div class="flex md12">
                <va-button
                  @click="closeModal"
                  class="fullwidth"
                  color="info"
                >Annuler</va-button>
              </div>
              <div class="flex md12">
                <va-button
                  @click="saveDevis"
                  class="fullwidth"
                  :color="isvalid"
                  :disabled="isvalid === 'info'"
                >Créer le devis</va-button>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-inside mt-4">
          <div class="flex md12">
            <h4>Engagements sur les numéros</h4>
          </div>
          <div class="flex md12">
            <div
              class="pub"
              v-for="publication in publicationsListeFiltered"
              :style="{ backgroundColor: backgroundColor(publication) }"
              @click="addAnnonce(publication)"
            >
              <div class="number">
                {{
					moment(
						publication.annee + "-" + publication.mois,
					  "YYYY-MM"
					).format("MMM YYYY")
				  }} </div>

            </div>
          </div>
        </div>
        <div class="row row-inside mt-4">
          <div class="flex md12">
            <h4>Annonces</h4>
          </div>
          <div class="flex md11">
            <div class="row row-inside">
              <div class="flex md1">Numéro</div>
              <div class="flex md1">Date prévisionnelle</div>
              <div class="flex md2">Nom</div>
              <div class="flex md1">Type</div>
              <div class="flex md1">Taille</div>
              <div class="flex md1">Montant</div>
              <div class="flex md1">Remises</div>
              <div class="flex md1">Total HT</div>
              <div class="flex md1">Facturation</div>
            </div>
          </div>
          <div
            class="flex md12 separated annonces"
            v-for="(annonce, index) in listeAnnonces"
            @click="selectAnnonce(index)"
          >
            <div class="row row-inside">
              <div class="flex md11">
                <div class="row row-inside">
                  <div class="flex md1">
                    {{
						moment(
							annonce.annee + "-" + annonce.mois,
						  "YYYY-MM"
						).format("MMM YYYY")
					  }}
                  </div>
                  <div class="flex md1">
                    {{ annonce.date_previsionnelle }}
                  </div>
                  <div class="flex md2">
                    {{ annonce.nom }}
                  </div>
                  <div class="flex md1">
                    {{ annonce.type }}
                  </div>
                  <div class="flex md1">{{ annonce.size }} Std</div>
                  <div class="flex md1">{{ annonce.montant }} €</div>
                  <div class="flex md1">
                    <p>{{ annonce.remise }} %</p>
                    <p>
                      {{ annonce.remise_fixe ? annonce.remise_fixe + "€" : "" }}
                    </p>
                  </div>
                  <div class="flex md1">
                    {{ montantTotal(annonce) }}
                    €
                  </div>
                  <div class="flex md1">
                    {{
                      annonce.idpartenaire_facturation ? "Autre" : "Standard"
                    }}
                    {{ annonce.idpartenaire_facturation }}
                  </div>
                  <div class="flex md2">
                    <va-select
                      :options="listTemplate"
                      v-model="templateSelect"
                      textBy="nom"
                      keyBy="idannonces_modele"
                      searchable
                      label="Recherche d'un template"
                    />
                  </div>
                </div>
              </div>
              <div class="flex md1">
                <div class="row row-inside">
                  <div class="flex md3 offset--md2">
                    <va-button
                      flat
                      icon="fa fa-edit"
                      color="info"
                      @click="editAnnonce(index)"
                    />
                  </div>
                  <div class="flex md5">
                    <va-button
                      flat
                      icon="fa fa-remove"
                      color="info"
                      @click="deleteAnnonce(index)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </va-modal>

    <va-modal
      class="modal"
      v-model="showModal"
      :okText="saveMessage"
      cancelText="Annuler"
      v-on:cancel="closeModifAnnonce"
      title="Editer Annonce"
      :hideDefaultActions="true"
    >
      <div
        class="force-width-medium"
        v-if="idAnnonce !== null"
      >
        <div class="flex md12">
          <div class="row row-inside">
            <div class="flex md5">
              <va-input
                disabled
                v-model="listeAnnonces[idAnnonce].moisTxt"
                placeholder="Numéro, Hors-série"
                label="Mois"
              />
            </div>
            <div class="flex md5 mx-1">
              <va-input
                disabled
                v-model="listeAnnonces[idAnnonce].annee"
                placeholder="Année"
                label="Année"
              />
            </div>
          </div>
        </div>
        <div class="flex md12">
          <va-input
            v-model="listeAnnonces[idAnnonce].nom"
            placeholder="Nom"
            label="Nom"
          />
        </div>
        <div class="flex md12">
          <va-input
            v-model="listeAnnonces[idAnnonce].commentaire"
            placeholder="Commentaire"
            label="Commentaire"
            type="textarea"
            :minRows="3"
            :maxRows="8"
          />
        </div>
        <div class="flex md12">
          <va-select
            :options="listType"
            v-model="listeAnnonces[idAnnonce].type"
            label="Type d'annonce"
          />
        </div>
        <div class="flex md12">
          <va-select
            :options="listSize"
            v-model="listeAnnonces[idAnnonce].size"
            label="Taille de l'annonce"
          />
        </div>
        <div class="flex md12 my-1">
          <va-checkbox
            v-model="specialBilling"
            label="Facturation spéciale"
          />
        </div>
        <div
          class="flex md12"
          v-show="specialBilling"
        >
          <va-select
            :options="partenairesListe"
            v-model="partenaireSpecialBilling"
            textBy="nom"
            keyBy="idpartenaire"
            searchable
            label="Recherche d'un annonceur"
          />
        </div>
        <div
          class="flex md12"
          v-show="specialBilling"
        >
          <va-select
            :options="listContactSpecialBilling"
            v-model="contactSpecialBilling"
            textBy="display"
            keyBy="idcontacts_partenaire"
            label="Adresse principale du devis"
          />
        </div>
        <div class="flex md12">
          <va-input
            v-model="listeAnnonces[idAnnonce].montant"
            placeholder="Montant"
            label="Montant"
            type="number"
            @input="updateMontant"
          />
        </div>
        <div class="flex md12">
          <div class="flex row row-inside">
            <div class="flex md6 pr-1">
              <va-input
                v-model="listeAnnonces[idAnnonce].remise"
                placeholder="Remise"
                label="Remise (%)"
                type="number"
                min="0"
                max="100"
                @input="updateRemiseFromPe"
              />
            </div>
            <div class="flex md6 pl-1">
              <va-input
                v-model="remiseChiffre"
                placeholder="Remise - Montant"
                label="Remise (€)"
                type="number"
                @input="updateRemiseFromNb"
              />
            </div>
          </div>
        </div>

        <div class="flex md12">
          <va-input
            v-model="listeAnnonces[idAnnonce].remise_fixe"
            placeholder="Remise"
            label="Remise additionnelle (€)"
            type="number"
          />
        </div>
        <div class="flex md12">
          <p>Montant total</p>
          <p>
            {{ montantTotal(listeAnnonces[idAnnonce]) }}
          </p>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { cloneDeep, find, isEqual, sortedUniq, sortBy, debounce } from "lodash";

export default {
  name: "devis-creation",
  props: ["value", "idnumero"],
  data() {
    return {
      attribution: false,
      showModal: false,
      moment: moment,
      showEdition: false,
      mainContactList: [],
      mainContact: { idcontacts_partenaire: null, display: null },
      partenairesListe: [],
      publicationsListe: [],
      listTemplate: [],
      listeAnnonces: [],
      partenaire: { idpartenaire: null, nom: null },
      partenaireSpecialBilling: { idpartenaire: null, nom: null },
      contactSpecialBilling: { idcontacts_partenaire: null },
      listContactSpecialBilling: [],
      idAnnonce: null,
      templateSelect: this.initTemplate(),
      listSize: ["1/4", "1/2", "1"],
      listType: ["presse"],
      action: false,
      specialBilling: false,
      mainContactDevis: { idcontacts_partenaire: null, display: null },
      tva_na: false,
      remiseChiffre: null,
      isprospection: false,
    };
  },
  mounted() {
    this.resetDevis();
    this.showEdition = this.value; // initialize internal variables
  },
  methods: {
    updateMontant: debounce(function (montant) {
      this.listeAnnonces[this.idAnnonce].montant = parseFloat(montant);
    }, 400),
    updateRemiseFromPe: debounce(function (remiseP) {
      // calculate the € corresponding to the %

      if (this.listeAnnonces[this.idAnnonce].montant) {
        this.remiseChiffre = (
          (this.listeAnnonces[this.idAnnonce].montant * remiseP) /
          100
        ).toFixed(2);
      }
    }, 400),
    updateRemiseFromNb: debounce(function (remiseNb) {
      // calculate the % needed to reach this remise
      if (this.listeAnnonces[this.idAnnonce].montant) {
        this.listeAnnonces[this.idAnnonce].remise = parseFloat(
          (
            (100 * remiseNb) /
            this.listeAnnonces[this.idAnnonce].montant
          ).toFixed(5)
        );
      }
    }, 400),
    montantTotal(annonce) {
      let montant = annonce.montant;
      let remise = annonce.remise;
      let remise_fixe = annonce.remise_fixe
        ? parseFloat(annonce.remise_fixe)
        : 0;
      return (montant * (1 - remise / 100) - remise_fixe).toFixed(2);
    },
    async saveDevis() {
      if (!this.$store.getters.user.publication_modifications) {
        this.launchEpicmaxToast("Droit insufisants");
        return;
      }
      try {
        if (this.isvalid !== "success") {
          this.launchEpicmaxToast("Devis invalide");
          return;
        }
        let devis = {
          idpartenaire: this.partenaire.idpartenaire,
          idcontacts_partenaire_billing: this.mainContact.idcontacts_partenaire,
          idcontacts_partenaire_devis:
            this.mainContactDevis.idcontacts_partenaire,
          listAnnonces: this.listeAnnonces,
          attribution: this.attribution,
          tva_na: this.tva_na,
          isprospection: this.isprospection,
        };

        let params = { devis: devis };

        let idDevis = await axios.post(
          "/api/publications-web/create-devis",
          params
        );

        this.launchEpicmaxToast("Devis créé");
        this.closeModal();
        this.$emit("newdevis");
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la sauvegarde du devis");
      }
    },
    validateAnnonce(annonce) {
      // check that an annonce is valid
      if (annonce.idpublication && annonce.type && annonce.montant > 0) {
        return true;
      } else {
        return false;
      }
    },
    closeModifAnnonce() {
      if (this.specialBilling) {
        this.listeAnnonces[this.idAnnonce].idpartenaire_facturation =
          this.partenaireSpecialBilling.idpartenaire;
        this.listeAnnonces[this.idAnnonce].idcontacts_partenaire_facturation =
          this.contactSpecialBilling.idcontacts_partenaire;
      }
      this.partenaireSpecialBilling = { idpartenaire: null };
      this.contactSpecialBilling = { idcontacts_partenaire: null };
      this.specialBilling = false;
      this.idAnnonce = null;
    },
    deleteAnnonce(index) {
      this.action = true;
      this.idAnnonce = null;
      this.listeAnnonces.splice(index, 1);
    },
    initTemplate() {
      return {};
    },
    editAnnonce(index) {
      this.action = true;
      this.idAnnonce = index;
      if (this.listeAnnonces[this.idAnnonce].idpartenaire_facturation) {
        this.specialBilling = true;
      } else {
        this.specialBilling = false;
      }
      if (
        this.listeAnnonces[this.idAnnonce].montant &&
        this.listeAnnonces[this.idAnnonce].remise
      ) {
        this.remiseChiffre = (
          (this.listeAnnonces[this.idAnnonce].montant *
            this.listeAnnonces[this.idAnnonce].remise) /
          100
        ).toFixed(2);
      } else {
        this.remiseChiffre = null;
      }
      this.showModal = true;
    },
    selectAnnonce(index) {
      if (this.action) {
        this.action = false;
        return;
      }
      this.idAnnonce = index;
    },
    addAnnonce(publication) {
      let now = moment();

      let datePublication = moment(publication.annee + '-' + publication.mois, "YYYY-MM");
      if (datePublication.isBefore(now.format("YYYY-MM"))) {
        this.launchEpicmaxToast("Annonces clôturé pour ce mois");
        //return;
      }

      this.listeAnnonces.push({
        idtmp: this.listeAnnonces.length,
        idpublication: publication.idpublication,
        annee: publication.annee,
        moisTxt: moment(publication.annee + '-' + publication.mois, "YYYY-MM").format("MMMM"),
        mois: publication.mois,
        montant: null,
        remise: null,
        remise_fixe: null,
        type: null,
        nom: null,
        size: null,
        idpartenaire_facturation: null,
        idcontacts_partenaire_facturation: null,
        commentaire: null,
      });
    },
    async loadTemplatesListe() {
      try {
        let resTmp = await axios.get("/api/publications-web/templateList");
        this.listTemplate = resTmp.data;
      } catch (error) {
        //todo message to user
        console.log(error);
      }
    },
    async loadPublicationListe() {
      try {
        let resTmp = await axios.get("/api/publications-web/list");
        this.publicationsListe = resTmp.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getAdresse(idpartenaire) {
      try {
        let resTmp = await axios.get(
          "/api/publications-web/liste-contacts-partenaire",
          {
            params: { idpartenaire: idpartenaire },
          }
        );
        this.partenairesListe = resTmp.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getContacts(idpartenaire) {
      try {
        let resTmp = await axios.get(
          "/api/publications-web/liste-contacts-partenaire",
          {
            params: { idpartenaire: idpartenaire },
          }
        );
        return resTmp.data;
      } catch (error) {
        console.log(error);
      }
    },
    async loadPartenairesListe() {
      try {
        let resTmp = await axios.get("/api/publications-web/liste-partenaires");
        this.partenairesListe = resTmp.data;
      } catch (error) {
        console.log(error);
      }
    },
    resetDevis() {
      this.loadPartenairesListe();
      this.loadPublicationListe();
      this.loadTemplatesListe();
      this.listeAnnonces = [];
      this.idAnnonce = null;
      this.mainContact = { idcontacts_partenaire: null, display: null };
      this.mainContactDevis = { idcontacts_partenaire: null, display: null };
      this.partenaire = { idpartenaire: null, nom: null };
      this.tva_na = false;
      this.isprospection = false;
      this.attribution = false;

      this.mainContactList = [];
    },

    async loadPublication() {
      try {
        if (!this.idnumero) {
          //erreur pas de numéro selectionné
          this.launchEpicmaxToast("Aucune publication séléctionnée");
          this.$emit("close", false);
          this.$emit("input", false);
          return;
        }

        let resTmp = await axios.get("api/publications-web/publication", {
          params: { idpublication: this.idnumero },
        });

        this.publication = cloneDeep(resTmp.data);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors du chargement de la publication");
      }
    },
    backgroundColor(element) {
      let now = moment();


      let dateElement = moment(element.annee + '-' + element.mois, "YYYY-MM");
      if (dateElement.isBefore(now.format("YYYY-MM"))) {
        return "#ccc"
      } else if (dateElement.format("YYYY-MM") === now.format("YYYY-MM")) {
        return "#4ae387"
      } else {
        return "#4ab2e3"
      }
    },

    closeModal() {
      this.resetDevis();
      this.$emit("close", false);
      this.$emit("input", false);
    },
    updateAnnonce(idannonce, values) {
      this.listeAnnonces[idannonce].nom = values.nom;
      this.listeAnnonces[idannonce].size = values.size;
      this.listeAnnonces[idannonce].montant = values.montant;
      this.listeAnnonces[idannonce].remise = values.remise;
      this.listeAnnonces[idannonce].remise_fixe = values.remise_fixe;
      this.listeAnnonces[idannonce].type = values.type;
      this.listeAnnonces[idannonce].commentaire = values.commentaire;
      this.idAnnonce = null;
      this.templateSelect = { idannonces_modele: null, nom: null };
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  computed: {
    isvalid: function () {
      if (this.partenaire.idpartenaire && this.listeAnnonces.length > 0) {
        for (let ijk = 0; ijk < this.listeAnnonces.length; ijk++) {
          if (!this.validateAnnonce(this.listeAnnonces[ijk])) {
            return "info";
          }
        }
        return "success";
      } else {
        return "info";
      }
    },
    montants: function () {
      let total = 0;
      let remise = 0;

      for (let ijk = 0; ijk < this.listeAnnonces.length; ijk++) {
        total += this.listeAnnonces[ijk].montant
          ? parseFloat(this.listeAnnonces[ijk].montant)
          : 0;
        remise += this.listeAnnonces[ijk].remise
          ? (parseFloat(this.listeAnnonces[ijk].remise) *
            parseFloat(this.listeAnnonces[ijk].montant)) /
          100
          : 0;
        remise += this.listeAnnonces[ijk].remise_fixe
          ? parseFloat(this.listeAnnonces[ijk].remise_fixe)
          : 0;
      }
      return { total: total.toFixed(2), remise: remise.toFixed(2) };
    },
    decomptePages: function () {
      let cptQuart = 0;
      let cptDemi = 0;
      let cptFull = 0;
      let total = 0;

      for (let ijk = 0; ijk < this.listeAnnonces.length; ijk++) {
        if (this.listeAnnonces[ijk].size === "1/4") {
          cptQuart += 1;
          total += 0.25;
        } else if (this.listeAnnonces[ijk].size === "1/2") {
          cptDemi += 1;
          total += 0.5;
        } else if (this.listeAnnonces[ijk].size === "1") {
          cptFull += 1;
          total += 1;
        }
      }

      return {
        text:
          +cptFull +
          " pages / " +
          cptDemi +
          " demis pages / " +
          cptQuart +
          " quarts de pages",
        total: total + " pages",
      };
    },
    decomptesNumeros: function () {
      let listeNumeros = [];
      for (let ijk = 0; ijk < this.listeAnnonces.length; ijk++) {
        listeNumeros.push(this.listeAnnonces[ijk].numero);
      }
      listeNumeros = sortedUniq(sortBy(listeNumeros));
      return listeNumeros.length;
    },
    publicationsListeFiltered: function () {
      return this.publicationsListe.filter((element) => {
        // filter out publications that are not active
        return true;
      });
    },
    saveMessage: function () {
      return "Fermer";
    },
  },
  watch: {
    specialBilling(newvalue) {
      if (newvalue) {
        if (this.listeAnnonces[this.idAnnonce].idpartenaire_facturation) {
          let tmp = {
            idpartenaire:
              this.listeAnnonces[this.idAnnonce].idpartenaire_facturation,
            nom: find(this.partenairesListe, {
              idpartenaire:
                this.listeAnnonces[this.idAnnonce].idpartenaire_facturation,
            }).nom,
          };

          // force watch without deep
          this.partenaireSpecialBilling = tmp;
        } else {
          this.partenaireSpecialBilling = this.partenaire;
          this.partenaireSpecialBilling.nom = find(this.partenairesListe, {
            idpartenaire: this.partenaireSpecialBilling.idpartenaire,
          }).nom;
        }
      } else {
        this.partenaireSpecialBilling = { idpartenaire: null };
        this.contactSpecialBilling = { idcontacts_partenaire: null };
      }
    },
    async partenaireSpecialBilling(newvalue, oldvalue) {
      if (newvalue.idpartenaire) {
        // load contact list
        let listContact = await this.getContacts(newvalue.idpartenaire);

        listContact.unshift({
          idcontacts_partenaire: null,
          display: "Entreprise - Adresse principale",
        });
        if (
          !this.listeAnnonces[this.idAnnonce]
            .idcontacts_partenaire_facturation ||
          newvalue.idpartenaire !==
          this.listeAnnonces[this.idAnnonce].idpartenaire_facturation
        ) {
          this.contactSpecialBilling = {
            idcontacts_partenaire: null,
            display: "Entreprise - Adresse principale",
          };
        } else {
          this.contactSpecialBilling = find(listContact, {
            idcontacts_partenaire:
              this.listeAnnonces[this.idAnnonce]
                .idcontacts_partenaire_facturation,
          });
        }

        this.listContactSpecialBilling = listContact;
      }
    },
    async partenaire(newvalue) {
      if (newvalue.idpartenaire) {
        console.log("test");
        let listContacts = await this.getContacts(newvalue.idpartenaire);
        this.mainContact = {
          idcontacts_partenaire: null,
          display: "Entreprise - Adresse principale",
        };
        this.mainContactDevis = {
          idcontacts_partenaire: null,
          display: "Entreprise - Adresse principale",
        };
        this.mainContactList = listContacts;
        this.mainContactList.unshift(this.mainContact);
      } else {
      }
    },
    templateSelect(newvalue) {
      if (newvalue.nom !== null) {
        this.updateAnnonce(this.idAnnonce, newvalue);
      }
    },
    value() {
      // Parent property changed; update internal variables
      this.showEdition = this.value;
      this.resetDevis();
    },
  },
};
</script>

<style lang="scss" scoped>
.popover {
  z-index: 1500;
}
.force-width-medium {
  width: 30vw;
  height: 60vh;
  overflow: auto;
}
.forcewidth {
  width: 85vw;
  height: 60vh;
  overflow: auto;
}
.fullwidth {
  width: 90%;
}

.pub {
  float: left;
  text-align: center;
  padding: 0.5em;
  color: white;
  margin: 0.5em;
}

.pub:hover {
  cursor: pointer;
}

.separated {
  border-bottom: solid 1px #ccc;
}

.annonces {
  padding: 10px;
}
.annonces:hover {
  background-color: rgb(223, 223, 223);
}
</style>
